var map = {
	"./prism-abap": [
		86405,
		86405
	],
	"./prism-abap.js": [
		86405,
		86405
	],
	"./prism-abap.min": [
		7062,
		7062
	],
	"./prism-abap.min.js": [
		7062,
		7062
	],
	"./prism-abnf": [
		68758,
		68758
	],
	"./prism-abnf.js": [
		68758,
		68758
	],
	"./prism-abnf.min": [
		48121,
		48121
	],
	"./prism-abnf.min.js": [
		48121,
		48121
	],
	"./prism-actionscript": [
		35249,
		35249
	],
	"./prism-actionscript.js": [
		35249,
		35249
	],
	"./prism-actionscript.min": [
		53896,
		53896
	],
	"./prism-actionscript.min.js": [
		53896,
		53896
	],
	"./prism-ada": [
		85795,
		85795
	],
	"./prism-ada.js": [
		85795,
		85795
	],
	"./prism-ada.min": [
		92497,
		92497
	],
	"./prism-ada.min.js": [
		92497,
		92497
	],
	"./prism-agda": [
		47231,
		47231
	],
	"./prism-agda.js": [
		47231,
		47231
	],
	"./prism-agda.min": [
		14552,
		14552
	],
	"./prism-agda.min.js": [
		14552,
		14552
	],
	"./prism-al": [
		42273,
		42273
	],
	"./prism-al.js": [
		42273,
		42273
	],
	"./prism-al.min": [
		47347,
		47347
	],
	"./prism-al.min.js": [
		47347,
		47347
	],
	"./prism-antlr4": [
		44852,
		44852
	],
	"./prism-antlr4.js": [
		44852,
		44852
	],
	"./prism-antlr4.min": [
		5527,
		5527
	],
	"./prism-antlr4.min.js": [
		5527,
		5527
	],
	"./prism-apacheconf": [
		77533,
		77533
	],
	"./prism-apacheconf.js": [
		77533,
		77533
	],
	"./prism-apacheconf.min": [
		24242,
		24242
	],
	"./prism-apacheconf.min.js": [
		24242,
		24242
	],
	"./prism-apex": [
		72594,
		72594
	],
	"./prism-apex.js": [
		72594,
		72594
	],
	"./prism-apex.min": [
		50516,
		50516
	],
	"./prism-apex.min.js": [
		50516,
		50516
	],
	"./prism-apl": [
		18508,
		18508
	],
	"./prism-apl.js": [
		18508,
		18508
	],
	"./prism-apl.min": [
		38162,
		38162
	],
	"./prism-apl.min.js": [
		38162,
		38162
	],
	"./prism-applescript": [
		31093,
		31093
	],
	"./prism-applescript.js": [
		31093,
		31093
	],
	"./prism-applescript.min": [
		39943,
		39943
	],
	"./prism-applescript.min.js": [
		39943,
		39943
	],
	"./prism-aql": [
		25691,
		25691
	],
	"./prism-aql.js": [
		25691,
		25691
	],
	"./prism-aql.min": [
		29846,
		29846
	],
	"./prism-aql.min.js": [
		29846,
		29846
	],
	"./prism-arduino": [
		51849,
		51849
	],
	"./prism-arduino.js": [
		51849,
		51849
	],
	"./prism-arduino.min": [
		71335,
		71335
	],
	"./prism-arduino.min.js": [
		71335,
		71335
	],
	"./prism-arff": [
		73253,
		73253
	],
	"./prism-arff.js": [
		73253,
		73253
	],
	"./prism-arff.min": [
		13955,
		13955
	],
	"./prism-arff.min.js": [
		13955,
		13955
	],
	"./prism-armasm": [
		24029,
		24029
	],
	"./prism-armasm.js": [
		24029,
		24029
	],
	"./prism-armasm.min": [
		87809,
		87809
	],
	"./prism-armasm.min.js": [
		87809,
		87809
	],
	"./prism-arturo": [
		2481,
		2481
	],
	"./prism-arturo.js": [
		2481,
		2481
	],
	"./prism-arturo.min": [
		53566,
		53566
	],
	"./prism-arturo.min.js": [
		53566,
		53566
	],
	"./prism-asciidoc": [
		10856,
		10856
	],
	"./prism-asciidoc.js": [
		10856,
		10856
	],
	"./prism-asciidoc.min": [
		55692,
		55692
	],
	"./prism-asciidoc.min.js": [
		55692,
		55692
	],
	"./prism-asm6502": [
		36972,
		36972
	],
	"./prism-asm6502.js": [
		36972,
		36972
	],
	"./prism-asm6502.min": [
		68409,
		68409
	],
	"./prism-asm6502.min.js": [
		68409,
		68409
	],
	"./prism-asmatmel": [
		36430,
		36430
	],
	"./prism-asmatmel.js": [
		36430,
		36430
	],
	"./prism-asmatmel.min": [
		40802,
		40802
	],
	"./prism-asmatmel.min.js": [
		40802,
		40802
	],
	"./prism-aspnet": [
		54019,
		54019
	],
	"./prism-aspnet.js": [
		54019,
		54019
	],
	"./prism-aspnet.min": [
		54780,
		54780
	],
	"./prism-aspnet.min.js": [
		54780,
		54780
	],
	"./prism-autohotkey": [
		92776,
		92776
	],
	"./prism-autohotkey.js": [
		92776,
		92776
	],
	"./prism-autohotkey.min": [
		531,
		531
	],
	"./prism-autohotkey.min.js": [
		531,
		531
	],
	"./prism-autoit": [
		24940,
		24940
	],
	"./prism-autoit.js": [
		24940,
		24940
	],
	"./prism-autoit.min": [
		20021,
		20021
	],
	"./prism-autoit.min.js": [
		20021,
		20021
	],
	"./prism-avisynth": [
		58060,
		58060
	],
	"./prism-avisynth.js": [
		58060,
		58060
	],
	"./prism-avisynth.min": [
		51508,
		51508
	],
	"./prism-avisynth.min.js": [
		51508,
		51508
	],
	"./prism-avro-idl": [
		639,
		639
	],
	"./prism-avro-idl.js": [
		639,
		639
	],
	"./prism-avro-idl.min": [
		9156,
		9156
	],
	"./prism-avro-idl.min.js": [
		9156,
		9156
	],
	"./prism-awk": [
		84126,
		84126
	],
	"./prism-awk.js": [
		84126,
		84126
	],
	"./prism-awk.min": [
		91595,
		91595
	],
	"./prism-awk.min.js": [
		91595,
		91595
	],
	"./prism-bash": [
		57874,
		57874
	],
	"./prism-bash.js": [
		57874,
		57874
	],
	"./prism-bash.min": [
		87013,
		87013
	],
	"./prism-bash.min.js": [
		87013,
		87013
	],
	"./prism-basic": [
		94446,
		94446
	],
	"./prism-basic.js": [
		94446,
		94446
	],
	"./prism-basic.min": [
		47098,
		47098
	],
	"./prism-basic.min.js": [
		47098,
		47098
	],
	"./prism-batch": [
		53292,
		53292
	],
	"./prism-batch.js": [
		53292,
		53292
	],
	"./prism-batch.min": [
		65965,
		65965
	],
	"./prism-batch.min.js": [
		65965,
		65965
	],
	"./prism-bbcode": [
		46428,
		46428
	],
	"./prism-bbcode.js": [
		46428,
		46428
	],
	"./prism-bbcode.min": [
		22661,
		22661
	],
	"./prism-bbcode.min.js": [
		22661,
		22661
	],
	"./prism-bbj": [
		27308,
		27308
	],
	"./prism-bbj.js": [
		27308,
		27308
	],
	"./prism-bbj.min": [
		8943,
		8943
	],
	"./prism-bbj.min.js": [
		8943,
		8943
	],
	"./prism-bicep": [
		86043,
		86043
	],
	"./prism-bicep.js": [
		86043,
		86043
	],
	"./prism-bicep.min": [
		74477,
		74477
	],
	"./prism-bicep.min.js": [
		74477,
		74477
	],
	"./prism-birb": [
		69104,
		69104
	],
	"./prism-birb.js": [
		69104,
		69104
	],
	"./prism-birb.min": [
		16997,
		16997
	],
	"./prism-birb.min.js": [
		16997,
		16997
	],
	"./prism-bison": [
		97861,
		97861
	],
	"./prism-bison.js": [
		97861,
		97861
	],
	"./prism-bison.min": [
		41248,
		41248
	],
	"./prism-bison.min.js": [
		41248,
		41248
	],
	"./prism-bnf": [
		24115,
		24115
	],
	"./prism-bnf.js": [
		24115,
		24115
	],
	"./prism-bnf.min": [
		86751,
		86751
	],
	"./prism-bnf.min.js": [
		86751,
		86751
	],
	"./prism-bqn": [
		50331,
		50331
	],
	"./prism-bqn.js": [
		50331,
		50331
	],
	"./prism-bqn.min": [
		60876,
		60876
	],
	"./prism-bqn.min.js": [
		60876,
		60876
	],
	"./prism-brainfuck": [
		15827,
		15827
	],
	"./prism-brainfuck.js": [
		15827,
		15827
	],
	"./prism-brainfuck.min": [
		99676,
		99676
	],
	"./prism-brainfuck.min.js": [
		99676,
		99676
	],
	"./prism-brightscript": [
		21275,
		21275
	],
	"./prism-brightscript.js": [
		21275,
		21275
	],
	"./prism-brightscript.min": [
		39455,
		39455
	],
	"./prism-brightscript.min.js": [
		39455,
		39455
	],
	"./prism-bro": [
		76609,
		76609
	],
	"./prism-bro.js": [
		76609,
		76609
	],
	"./prism-bro.min": [
		28708,
		28708
	],
	"./prism-bro.min.js": [
		28708,
		28708
	],
	"./prism-bsl": [
		61354,
		61354
	],
	"./prism-bsl.js": [
		61354,
		61354
	],
	"./prism-bsl.min": [
		29402,
		29402
	],
	"./prism-bsl.min.js": [
		29402,
		29402
	],
	"./prism-c": [
		4279,
		4279
	],
	"./prism-c.js": [
		4279,
		4279
	],
	"./prism-c.min": [
		36551,
		36551
	],
	"./prism-c.min.js": [
		36551,
		36551
	],
	"./prism-cfscript": [
		86902,
		86902
	],
	"./prism-cfscript.js": [
		86902,
		86902
	],
	"./prism-cfscript.min": [
		45890,
		45890
	],
	"./prism-cfscript.min.js": [
		45890,
		45890
	],
	"./prism-chaiscript": [
		64681,
		64681
	],
	"./prism-chaiscript.js": [
		64681,
		64681
	],
	"./prism-chaiscript.min": [
		55705,
		55705
	],
	"./prism-chaiscript.min.js": [
		55705,
		55705
	],
	"./prism-cil": [
		4677,
		4677
	],
	"./prism-cil.js": [
		4677,
		4677
	],
	"./prism-cil.min": [
		54002,
		54002
	],
	"./prism-cil.min.js": [
		54002,
		54002
	],
	"./prism-cilkc": [
		99114,
		99114
	],
	"./prism-cilkc.js": [
		99114,
		99114
	],
	"./prism-cilkc.min": [
		97298,
		97298
	],
	"./prism-cilkc.min.js": [
		97298,
		97298
	],
	"./prism-cilkcpp": [
		5798,
		5798
	],
	"./prism-cilkcpp.js": [
		5798,
		5798
	],
	"./prism-cilkcpp.min": [
		87850,
		87850
	],
	"./prism-cilkcpp.min.js": [
		87850,
		87850
	],
	"./prism-clike": [
		35433,
		35433
	],
	"./prism-clike.js": [
		35433,
		35433
	],
	"./prism-clike.min": [
		58080,
		58080
	],
	"./prism-clike.min.js": [
		58080,
		58080
	],
	"./prism-clojure": [
		52812,
		52812
	],
	"./prism-clojure.js": [
		52812,
		52812
	],
	"./prism-clojure.min": [
		14821,
		14821
	],
	"./prism-clojure.min.js": [
		14821,
		14821
	],
	"./prism-cmake": [
		44225,
		44225
	],
	"./prism-cmake.js": [
		44225,
		44225
	],
	"./prism-cmake.min": [
		79278,
		79278
	],
	"./prism-cmake.min.js": [
		79278,
		79278
	],
	"./prism-cobol": [
		57649,
		57649
	],
	"./prism-cobol.js": [
		57649,
		57649
	],
	"./prism-cobol.min": [
		42165,
		42165
	],
	"./prism-cobol.min.js": [
		42165,
		42165
	],
	"./prism-coffeescript": [
		46213,
		46213
	],
	"./prism-coffeescript.js": [
		46213,
		46213
	],
	"./prism-coffeescript.min": [
		37271,
		37271
	],
	"./prism-coffeescript.min.js": [
		37271,
		37271
	],
	"./prism-concurnas": [
		29467,
		29467
	],
	"./prism-concurnas.js": [
		29467,
		29467
	],
	"./prism-concurnas.min": [
		2836,
		2836
	],
	"./prism-concurnas.min.js": [
		2836,
		2836
	],
	"./prism-cooklang": [
		25867,
		25867
	],
	"./prism-cooklang.js": [
		25867,
		25867
	],
	"./prism-cooklang.min": [
		35518,
		35518
	],
	"./prism-cooklang.min.js": [
		35518,
		35518
	],
	"./prism-coq": [
		74307,
		74307
	],
	"./prism-coq.js": [
		74307,
		74307
	],
	"./prism-coq.min": [
		68251,
		68251
	],
	"./prism-coq.min.js": [
		68251,
		68251
	],
	"./prism-core": [
		28325,
		28325
	],
	"./prism-core.js": [
		28325,
		28325
	],
	"./prism-core.min": [
		2251,
		2251
	],
	"./prism-core.min.js": [
		2251,
		2251
	],
	"./prism-cpp": [
		2731,
		2731
	],
	"./prism-cpp.js": [
		2731,
		2731
	],
	"./prism-cpp.min": [
		54132,
		54132
	],
	"./prism-cpp.min.js": [
		54132,
		54132
	],
	"./prism-crystal": [
		18980,
		18980
	],
	"./prism-crystal.js": [
		18980,
		18980
	],
	"./prism-crystal.min": [
		77223,
		77223
	],
	"./prism-crystal.min.js": [
		77223,
		77223
	],
	"./prism-csharp": [
		79016,
		79016
	],
	"./prism-csharp.js": [
		79016,
		79016
	],
	"./prism-csharp.min": [
		53229,
		53229
	],
	"./prism-csharp.min.js": [
		53229,
		53229
	],
	"./prism-cshtml": [
		63326,
		63326
	],
	"./prism-cshtml.js": [
		63326,
		63326
	],
	"./prism-cshtml.min": [
		52224,
		33989
	],
	"./prism-cshtml.min.js": [
		52224,
		33989
	],
	"./prism-csp": [
		4412,
		4412
	],
	"./prism-csp.js": [
		4412,
		4412
	],
	"./prism-csp.min": [
		12926,
		12926
	],
	"./prism-csp.min.js": [
		12926,
		12926
	],
	"./prism-css": [
		15251,
		15251
	],
	"./prism-css-extras": [
		80871,
		80871
	],
	"./prism-css-extras.js": [
		80871,
		80871
	],
	"./prism-css-extras.min": [
		61710,
		61710
	],
	"./prism-css-extras.min.js": [
		61710,
		61710
	],
	"./prism-css.js": [
		15251,
		15251
	],
	"./prism-css.min": [
		12247,
		12247
	],
	"./prism-css.min.js": [
		12247,
		12247
	],
	"./prism-csv": [
		97899,
		97899
	],
	"./prism-csv.js": [
		97899,
		97899
	],
	"./prism-csv.min": [
		28341,
		28341
	],
	"./prism-csv.min.js": [
		28341,
		28341
	],
	"./prism-cue": [
		2946,
		2946
	],
	"./prism-cue.js": [
		2946,
		2946
	],
	"./prism-cue.min": [
		99938,
		99938
	],
	"./prism-cue.min.js": [
		99938,
		99938
	],
	"./prism-cypher": [
		30258,
		30258
	],
	"./prism-cypher.js": [
		30258,
		30258
	],
	"./prism-cypher.min": [
		99860,
		99860
	],
	"./prism-cypher.min.js": [
		99860,
		99860
	],
	"./prism-d": [
		58149,
		58149
	],
	"./prism-d.js": [
		58149,
		58149
	],
	"./prism-d.min": [
		3525,
		3525
	],
	"./prism-d.min.js": [
		3525,
		3525
	],
	"./prism-dart": [
		57065,
		57065
	],
	"./prism-dart.js": [
		57065,
		57065
	],
	"./prism-dart.min": [
		80974,
		80974
	],
	"./prism-dart.min.js": [
		80974,
		80974
	],
	"./prism-dataweave": [
		73162,
		73162
	],
	"./prism-dataweave.js": [
		73162,
		73162
	],
	"./prism-dataweave.min": [
		65897,
		65897
	],
	"./prism-dataweave.min.js": [
		65897,
		65897
	],
	"./prism-dax": [
		90827,
		90827
	],
	"./prism-dax.js": [
		90827,
		90827
	],
	"./prism-dax.min": [
		19486,
		19486
	],
	"./prism-dax.min.js": [
		19486,
		19486
	],
	"./prism-dhall": [
		24370,
		24370
	],
	"./prism-dhall.js": [
		24370,
		24370
	],
	"./prism-dhall.min": [
		87981,
		87981
	],
	"./prism-dhall.min.js": [
		87981,
		87981
	],
	"./prism-diff": [
		40728,
		40728
	],
	"./prism-diff.js": [
		40728,
		40728
	],
	"./prism-diff.min": [
		72734,
		72734
	],
	"./prism-diff.min.js": [
		72734,
		72734
	],
	"./prism-django": [
		54409,
		54409
	],
	"./prism-django.js": [
		54409,
		54409
	],
	"./prism-django.min": [
		85534,
		85534
	],
	"./prism-django.min.js": [
		85534,
		85534
	],
	"./prism-dns-zone-file": [
		68483,
		68483
	],
	"./prism-dns-zone-file.js": [
		68483,
		68483
	],
	"./prism-dns-zone-file.min": [
		67659,
		67659
	],
	"./prism-dns-zone-file.min.js": [
		67659,
		67659
	],
	"./prism-docker": [
		77158,
		77158
	],
	"./prism-docker.js": [
		77158,
		77158
	],
	"./prism-docker.min": [
		74280,
		74280
	],
	"./prism-docker.min.js": [
		74280,
		74280
	],
	"./prism-dot": [
		60397,
		60397
	],
	"./prism-dot.js": [
		60397,
		60397
	],
	"./prism-dot.min": [
		26141,
		26141
	],
	"./prism-dot.min.js": [
		26141,
		26141
	],
	"./prism-ebnf": [
		68232,
		68232
	],
	"./prism-ebnf.js": [
		68232,
		68232
	],
	"./prism-ebnf.min": [
		79543,
		79543
	],
	"./prism-ebnf.min.js": [
		79543,
		79543
	],
	"./prism-editorconfig": [
		22456,
		22456
	],
	"./prism-editorconfig.js": [
		22456,
		22456
	],
	"./prism-editorconfig.min": [
		41880,
		41880
	],
	"./prism-editorconfig.min.js": [
		41880,
		41880
	],
	"./prism-eiffel": [
		59979,
		59979
	],
	"./prism-eiffel.js": [
		59979,
		59979
	],
	"./prism-eiffel.min": [
		2891,
		2891
	],
	"./prism-eiffel.min.js": [
		2891,
		2891
	],
	"./prism-ejs": [
		70060,
		70060
	],
	"./prism-ejs.js": [
		70060,
		70060
	],
	"./prism-ejs.min": [
		65823,
		65823
	],
	"./prism-ejs.min.js": [
		65823,
		65823
	],
	"./prism-elixir": [
		68805,
		68805
	],
	"./prism-elixir.js": [
		68805,
		68805
	],
	"./prism-elixir.min": [
		43045,
		43045
	],
	"./prism-elixir.min.js": [
		43045,
		43045
	],
	"./prism-elm": [
		75041,
		75041
	],
	"./prism-elm.js": [
		75041,
		75041
	],
	"./prism-elm.min": [
		84269,
		84269
	],
	"./prism-elm.min.js": [
		84269,
		84269
	],
	"./prism-erb": [
		66512,
		66512
	],
	"./prism-erb.js": [
		66512,
		66512
	],
	"./prism-erb.min": [
		83000,
		83000
	],
	"./prism-erb.min.js": [
		83000,
		83000
	],
	"./prism-erlang": [
		8956,
		8956
	],
	"./prism-erlang.js": [
		8956,
		8956
	],
	"./prism-erlang.min": [
		39540,
		39540
	],
	"./prism-erlang.min.js": [
		39540,
		39540
	],
	"./prism-etlua": [
		79958,
		79958
	],
	"./prism-etlua.js": [
		79958,
		79958
	],
	"./prism-etlua.min": [
		16195,
		16195
	],
	"./prism-etlua.min.js": [
		16195,
		16195
	],
	"./prism-excel-formula": [
		51039,
		51039
	],
	"./prism-excel-formula.js": [
		51039,
		51039
	],
	"./prism-excel-formula.min": [
		78876,
		78876
	],
	"./prism-excel-formula.min.js": [
		78876,
		78876
	],
	"./prism-factor": [
		50171,
		50171
	],
	"./prism-factor.js": [
		50171,
		50171
	],
	"./prism-factor.min": [
		16302,
		16302
	],
	"./prism-factor.min.js": [
		16302,
		16302
	],
	"./prism-false": [
		10427,
		10427
	],
	"./prism-false.js": [
		10427,
		10427
	],
	"./prism-false.min": [
		61259,
		61259
	],
	"./prism-false.min.js": [
		61259,
		61259
	],
	"./prism-firestore-security-rules": [
		6634,
		6634
	],
	"./prism-firestore-security-rules.js": [
		6634,
		6634
	],
	"./prism-firestore-security-rules.min": [
		67128,
		67128
	],
	"./prism-firestore-security-rules.min.js": [
		67128,
		67128
	],
	"./prism-flow": [
		9220,
		9220
	],
	"./prism-flow.js": [
		9220,
		9220
	],
	"./prism-flow.min": [
		96017,
		96017
	],
	"./prism-flow.min.js": [
		96017,
		96017
	],
	"./prism-fortran": [
		27915,
		27915
	],
	"./prism-fortran.js": [
		27915,
		27915
	],
	"./prism-fortran.min": [
		70975,
		70975
	],
	"./prism-fortran.min.js": [
		70975,
		70975
	],
	"./prism-fsharp": [
		75045,
		75045
	],
	"./prism-fsharp.js": [
		75045,
		75045
	],
	"./prism-fsharp.min": [
		25001,
		25001
	],
	"./prism-fsharp.min.js": [
		25001,
		25001
	],
	"./prism-ftl": [
		72778,
		72778
	],
	"./prism-ftl.js": [
		72778,
		72778
	],
	"./prism-ftl.min": [
		76831,
		76831
	],
	"./prism-ftl.min.js": [
		76831,
		76831
	],
	"./prism-gap": [
		91709,
		91709
	],
	"./prism-gap.js": [
		91709,
		91709
	],
	"./prism-gap.min": [
		40327,
		40327
	],
	"./prism-gap.min.js": [
		40327,
		40327
	],
	"./prism-gcode": [
		28407,
		28407
	],
	"./prism-gcode.js": [
		28407,
		28407
	],
	"./prism-gcode.min": [
		9303,
		9303
	],
	"./prism-gcode.min.js": [
		9303,
		9303
	],
	"./prism-gdscript": [
		65276,
		65276
	],
	"./prism-gdscript.js": [
		65276,
		65276
	],
	"./prism-gdscript.min": [
		20563,
		20563
	],
	"./prism-gdscript.min.js": [
		20563,
		20563
	],
	"./prism-gedcom": [
		66857,
		66857
	],
	"./prism-gedcom.js": [
		66857,
		66857
	],
	"./prism-gedcom.min": [
		17065,
		17065
	],
	"./prism-gedcom.min.js": [
		17065,
		17065
	],
	"./prism-gettext": [
		51315,
		51315
	],
	"./prism-gettext.js": [
		51315,
		51315
	],
	"./prism-gettext.min": [
		92082,
		92082
	],
	"./prism-gettext.min.js": [
		92082,
		92082
	],
	"./prism-gherkin": [
		49472,
		49472
	],
	"./prism-gherkin.js": [
		49472,
		49472
	],
	"./prism-gherkin.min": [
		19876,
		19876
	],
	"./prism-gherkin.min.js": [
		19876,
		19876
	],
	"./prism-git": [
		79787,
		79787
	],
	"./prism-git.js": [
		79787,
		79787
	],
	"./prism-git.min": [
		93530,
		93530
	],
	"./prism-git.min.js": [
		93530,
		93530
	],
	"./prism-glsl": [
		79812,
		79812
	],
	"./prism-glsl.js": [
		79812,
		79812
	],
	"./prism-glsl.min": [
		58575,
		58575
	],
	"./prism-glsl.min.js": [
		58575,
		58575
	],
	"./prism-gml": [
		71828,
		71828
	],
	"./prism-gml.js": [
		71828,
		71828
	],
	"./prism-gml.min": [
		81813,
		81813
	],
	"./prism-gml.min.js": [
		81813,
		81813
	],
	"./prism-gn": [
		1415,
		1415
	],
	"./prism-gn.js": [
		1415,
		1415
	],
	"./prism-gn.min": [
		7850,
		7850
	],
	"./prism-gn.min.js": [
		7850,
		7850
	],
	"./prism-go": [
		27046,
		27046
	],
	"./prism-go-module": [
		77346,
		77346
	],
	"./prism-go-module.js": [
		77346,
		77346
	],
	"./prism-go-module.min": [
		59109,
		59109
	],
	"./prism-go-module.min.js": [
		59109,
		59109
	],
	"./prism-go.js": [
		27046,
		27046
	],
	"./prism-go.min": [
		50677,
		50677
	],
	"./prism-go.min.js": [
		50677,
		50677
	],
	"./prism-gradle": [
		31565,
		31565
	],
	"./prism-gradle.js": [
		31565,
		31565
	],
	"./prism-gradle.min": [
		9662,
		9662
	],
	"./prism-gradle.min.js": [
		9662,
		9662
	],
	"./prism-graphql": [
		17117,
		17117
	],
	"./prism-graphql.js": [
		17117,
		17117
	],
	"./prism-graphql.min": [
		11530,
		11530
	],
	"./prism-graphql.min.js": [
		11530,
		11530
	],
	"./prism-groovy": [
		40485,
		40485
	],
	"./prism-groovy.js": [
		40485,
		40485
	],
	"./prism-groovy.min": [
		29627,
		29627
	],
	"./prism-groovy.min.js": [
		29627,
		29627
	],
	"./prism-haml": [
		39181,
		39181
	],
	"./prism-haml.js": [
		39181,
		39181
	],
	"./prism-haml.min": [
		53025,
		53025
	],
	"./prism-haml.min.js": [
		53025,
		53025
	],
	"./prism-handlebars": [
		70110,
		70110
	],
	"./prism-handlebars.js": [
		70110,
		70110
	],
	"./prism-handlebars.min": [
		34329,
		34329
	],
	"./prism-handlebars.min.js": [
		34329,
		34329
	],
	"./prism-haskell": [
		81295,
		81295
	],
	"./prism-haskell.js": [
		81295,
		81295
	],
	"./prism-haskell.min": [
		12199,
		12199
	],
	"./prism-haskell.min.js": [
		12199,
		12199
	],
	"./prism-haxe": [
		14324,
		14324
	],
	"./prism-haxe.js": [
		14324,
		14324
	],
	"./prism-haxe.min": [
		40714,
		40714
	],
	"./prism-haxe.min.js": [
		40714,
		40714
	],
	"./prism-hcl": [
		24677,
		24677
	],
	"./prism-hcl.js": [
		24677,
		24677
	],
	"./prism-hcl.min": [
		7044,
		7044
	],
	"./prism-hcl.min.js": [
		7044,
		7044
	],
	"./prism-hlsl": [
		5578,
		5578
	],
	"./prism-hlsl.js": [
		5578,
		5578
	],
	"./prism-hlsl.min": [
		62058,
		62058
	],
	"./prism-hlsl.min.js": [
		62058,
		62058
	],
	"./prism-hoon": [
		88161,
		88161
	],
	"./prism-hoon.js": [
		88161,
		88161
	],
	"./prism-hoon.min": [
		91246,
		91246
	],
	"./prism-hoon.min.js": [
		91246,
		91246
	],
	"./prism-hpkp": [
		26203,
		26203
	],
	"./prism-hpkp.js": [
		26203,
		26203
	],
	"./prism-hpkp.min": [
		67623,
		67623
	],
	"./prism-hpkp.min.js": [
		67623,
		67623
	],
	"./prism-hsts": [
		17786,
		17786
	],
	"./prism-hsts.js": [
		17786,
		17786
	],
	"./prism-hsts.min": [
		23808,
		23808
	],
	"./prism-hsts.min.js": [
		23808,
		23808
	],
	"./prism-http": [
		50057,
		50057
	],
	"./prism-http.js": [
		50057,
		50057
	],
	"./prism-http.min": [
		587,
		587
	],
	"./prism-http.min.js": [
		587,
		587
	],
	"./prism-ichigojam": [
		77460,
		77460
	],
	"./prism-ichigojam.js": [
		77460,
		77460
	],
	"./prism-ichigojam.min": [
		54111,
		54111
	],
	"./prism-ichigojam.min.js": [
		54111,
		54111
	],
	"./prism-icon": [
		54263,
		54263
	],
	"./prism-icon.js": [
		54263,
		54263
	],
	"./prism-icon.min": [
		45477,
		45477
	],
	"./prism-icon.min.js": [
		45477,
		45477
	],
	"./prism-icu-message-format": [
		90175,
		90175
	],
	"./prism-icu-message-format.js": [
		90175,
		90175
	],
	"./prism-icu-message-format.min": [
		48209,
		48209
	],
	"./prism-icu-message-format.min.js": [
		48209,
		48209
	],
	"./prism-idris": [
		16150,
		16150
	],
	"./prism-idris.js": [
		16150,
		16150
	],
	"./prism-idris.min": [
		75649,
		75649
	],
	"./prism-idris.min.js": [
		75649,
		75649
	],
	"./prism-iecst": [
		55689,
		55689
	],
	"./prism-iecst.js": [
		55689,
		55689
	],
	"./prism-iecst.min": [
		17238,
		17238
	],
	"./prism-iecst.min.js": [
		17238,
		17238
	],
	"./prism-ignore": [
		10880,
		10880
	],
	"./prism-ignore.js": [
		10880,
		10880
	],
	"./prism-ignore.min": [
		47122,
		47122
	],
	"./prism-ignore.min.js": [
		47122,
		47122
	],
	"./prism-inform7": [
		56521,
		56521
	],
	"./prism-inform7.js": [
		56521,
		56521
	],
	"./prism-inform7.min": [
		26293,
		26293
	],
	"./prism-inform7.min.js": [
		26293,
		26293
	],
	"./prism-ini": [
		29525,
		29525
	],
	"./prism-ini.js": [
		29525,
		29525
	],
	"./prism-ini.min": [
		19475,
		19475
	],
	"./prism-ini.min.js": [
		19475,
		19475
	],
	"./prism-io": [
		48942,
		48942
	],
	"./prism-io.js": [
		48942,
		48942
	],
	"./prism-io.min": [
		93154,
		93154
	],
	"./prism-io.min.js": [
		93154,
		93154
	],
	"./prism-j": [
		18848,
		18848
	],
	"./prism-j.js": [
		18848,
		18848
	],
	"./prism-j.min": [
		78067,
		78067
	],
	"./prism-j.min.js": [
		78067,
		78067
	],
	"./prism-java": [
		52503,
		52503
	],
	"./prism-java.js": [
		52503,
		52503
	],
	"./prism-java.min": [
		17706,
		17706
	],
	"./prism-java.min.js": [
		17706,
		17706
	],
	"./prism-javadoc": [
		52008,
		52008
	],
	"./prism-javadoc.js": [
		52008,
		52008
	],
	"./prism-javadoc.min": [
		78792,
		78792
	],
	"./prism-javadoc.min.js": [
		78792,
		78792
	],
	"./prism-javadoclike": [
		54884,
		54884
	],
	"./prism-javadoclike.js": [
		54884,
		54884
	],
	"./prism-javadoclike.min": [
		97854,
		97854
	],
	"./prism-javadoclike.min.js": [
		97854,
		97854
	],
	"./prism-javascript": [
		39980,
		39980
	],
	"./prism-javascript.js": [
		39980,
		39980
	],
	"./prism-javascript.min": [
		30235,
		30235
	],
	"./prism-javascript.min.js": [
		30235,
		30235
	],
	"./prism-javastacktrace": [
		81454,
		81454
	],
	"./prism-javastacktrace.js": [
		81454,
		81454
	],
	"./prism-javastacktrace.min": [
		39837,
		39837
	],
	"./prism-javastacktrace.min.js": [
		39837,
		39837
	],
	"./prism-jexl": [
		55314,
		55314
	],
	"./prism-jexl.js": [
		55314,
		55314
	],
	"./prism-jexl.min": [
		66116,
		66116
	],
	"./prism-jexl.min.js": [
		66116,
		66116
	],
	"./prism-jolie": [
		68874,
		68874
	],
	"./prism-jolie.js": [
		68874,
		68874
	],
	"./prism-jolie.min": [
		91429,
		91429
	],
	"./prism-jolie.min.js": [
		91429,
		91429
	],
	"./prism-jq": [
		96342,
		96342
	],
	"./prism-jq.js": [
		96342,
		96342
	],
	"./prism-jq.min": [
		92771,
		92771
	],
	"./prism-jq.min.js": [
		92771,
		92771
	],
	"./prism-js-extras": [
		46690,
		46690
	],
	"./prism-js-extras.js": [
		46690,
		46690
	],
	"./prism-js-extras.min": [
		49273,
		49273
	],
	"./prism-js-extras.min.js": [
		49273,
		49273
	],
	"./prism-js-templates": [
		38885,
		38885
	],
	"./prism-js-templates.js": [
		38885,
		38885
	],
	"./prism-js-templates.min": [
		3908,
		3908
	],
	"./prism-js-templates.min.js": [
		3908,
		3908
	],
	"./prism-jsdoc": [
		68915,
		68915
	],
	"./prism-jsdoc.js": [
		68915,
		68915
	],
	"./prism-jsdoc.min": [
		27472,
		27472
	],
	"./prism-jsdoc.min.js": [
		27472,
		27472
	],
	"./prism-json": [
		74277,
		74277
	],
	"./prism-json.js": [
		74277,
		74277
	],
	"./prism-json.min": [
		8674,
		8674
	],
	"./prism-json.min.js": [
		8674,
		8674
	],
	"./prism-json5": [
		22444,
		22444
	],
	"./prism-json5.js": [
		22444,
		22444
	],
	"./prism-json5.min": [
		54001,
		54001
	],
	"./prism-json5.min.js": [
		54001,
		54001
	],
	"./prism-jsonp": [
		64488,
		64488
	],
	"./prism-jsonp.js": [
		64488,
		64488
	],
	"./prism-jsonp.min": [
		81286,
		81286
	],
	"./prism-jsonp.min.js": [
		81286,
		81286
	],
	"./prism-jsstacktrace": [
		81917,
		81917
	],
	"./prism-jsstacktrace.js": [
		81917,
		81917
	],
	"./prism-jsstacktrace.min": [
		68152,
		68152
	],
	"./prism-jsstacktrace.min.js": [
		68152,
		68152
	],
	"./prism-jsx": [
		62356,
		62356
	],
	"./prism-jsx.js": [
		62356,
		62356
	],
	"./prism-jsx.min": [
		81233,
		81233
	],
	"./prism-jsx.min.js": [
		81233,
		81233
	],
	"./prism-julia": [
		56543,
		56543
	],
	"./prism-julia.js": [
		56543,
		56543
	],
	"./prism-julia.min": [
		82580,
		82580
	],
	"./prism-julia.min.js": [
		82580,
		82580
	],
	"./prism-keepalived": [
		71643,
		71643
	],
	"./prism-keepalived.js": [
		71643,
		71643
	],
	"./prism-keepalived.min": [
		25767,
		25767
	],
	"./prism-keepalived.min.js": [
		25767,
		25767
	],
	"./prism-keyman": [
		82821,
		82821
	],
	"./prism-keyman.js": [
		82821,
		82821
	],
	"./prism-keyman.min": [
		51064,
		51064
	],
	"./prism-keyman.min.js": [
		51064,
		51064
	],
	"./prism-kotlin": [
		32334,
		32334
	],
	"./prism-kotlin.js": [
		32334,
		32334
	],
	"./prism-kotlin.min": [
		44002,
		44002
	],
	"./prism-kotlin.min.js": [
		44002,
		44002
	],
	"./prism-kumir": [
		69486,
		69486
	],
	"./prism-kumir.js": [
		69486,
		69486
	],
	"./prism-kumir.min": [
		85389,
		85389
	],
	"./prism-kumir.min.js": [
		85389,
		85389
	],
	"./prism-kusto": [
		31634,
		31634
	],
	"./prism-kusto.js": [
		31634,
		31634
	],
	"./prism-kusto.min": [
		28368,
		28368
	],
	"./prism-kusto.min.js": [
		28368,
		28368
	],
	"./prism-latex": [
		90319,
		90319
	],
	"./prism-latex.js": [
		90319,
		90319
	],
	"./prism-latex.min": [
		99119,
		99119
	],
	"./prism-latex.min.js": [
		99119,
		99119
	],
	"./prism-latte": [
		87442,
		87442
	],
	"./prism-latte.js": [
		87442,
		87442
	],
	"./prism-latte.min": [
		29908,
		29908
	],
	"./prism-latte.min.js": [
		29908,
		29908
	],
	"./prism-less": [
		37802,
		37802
	],
	"./prism-less.js": [
		37802,
		37802
	],
	"./prism-less.min": [
		64006,
		64006
	],
	"./prism-less.min.js": [
		64006,
		64006
	],
	"./prism-lilypond": [
		61719,
		61719
	],
	"./prism-lilypond.js": [
		61719,
		61719
	],
	"./prism-lilypond.min": [
		12555,
		12555
	],
	"./prism-lilypond.min.js": [
		12555,
		12555
	],
	"./prism-linker-script": [
		47362,
		47362
	],
	"./prism-linker-script.js": [
		47362,
		47362
	],
	"./prism-linker-script.min": [
		25731,
		25731
	],
	"./prism-linker-script.min.js": [
		25731,
		25731
	],
	"./prism-liquid": [
		150,
		150
	],
	"./prism-liquid.js": [
		150,
		150
	],
	"./prism-liquid.min": [
		55728,
		55728
	],
	"./prism-liquid.min.js": [
		55728,
		55728
	],
	"./prism-lisp": [
		45520,
		45520
	],
	"./prism-lisp.js": [
		45520,
		45520
	],
	"./prism-lisp.min": [
		87770,
		87770
	],
	"./prism-lisp.min.js": [
		87770,
		87770
	],
	"./prism-livescript": [
		76347,
		76347
	],
	"./prism-livescript.js": [
		76347,
		76347
	],
	"./prism-livescript.min": [
		41163,
		41163
	],
	"./prism-livescript.min.js": [
		41163,
		41163
	],
	"./prism-llvm": [
		85153,
		85153
	],
	"./prism-llvm.js": [
		85153,
		85153
	],
	"./prism-llvm.min": [
		82932,
		82932
	],
	"./prism-llvm.min.js": [
		82932,
		82932
	],
	"./prism-log": [
		93335,
		93335
	],
	"./prism-log.js": [
		93335,
		93335
	],
	"./prism-log.min": [
		61762,
		61762
	],
	"./prism-log.min.js": [
		61762,
		61762
	],
	"./prism-lolcode": [
		26555,
		26555
	],
	"./prism-lolcode.js": [
		26555,
		26555
	],
	"./prism-lolcode.min": [
		10076,
		10076
	],
	"./prism-lolcode.min.js": [
		10076,
		10076
	],
	"./prism-lua": [
		66841,
		66841
	],
	"./prism-lua.js": [
		66841,
		66841
	],
	"./prism-lua.min": [
		63047,
		63047
	],
	"./prism-lua.min.js": [
		63047,
		63047
	],
	"./prism-magma": [
		6004,
		6004
	],
	"./prism-magma.js": [
		6004,
		6004
	],
	"./prism-magma.min": [
		27788,
		27788
	],
	"./prism-magma.min.js": [
		27788,
		27788
	],
	"./prism-makefile": [
		48443,
		48443
	],
	"./prism-makefile.js": [
		48443,
		48443
	],
	"./prism-makefile.min": [
		75151,
		75151
	],
	"./prism-makefile.min.js": [
		75151,
		75151
	],
	"./prism-markdown": [
		24064,
		24064
	],
	"./prism-markdown.js": [
		24064,
		24064
	],
	"./prism-markdown.min": [
		90047,
		90047
	],
	"./prism-markdown.min.js": [
		90047,
		90047
	],
	"./prism-markup": [
		24335,
		24335
	],
	"./prism-markup-templating": [
		96854,
		96854
	],
	"./prism-markup-templating.js": [
		96854,
		96854
	],
	"./prism-markup-templating.min": [
		48929,
		48929
	],
	"./prism-markup-templating.min.js": [
		48929,
		48929
	],
	"./prism-markup.js": [
		24335,
		24335
	],
	"./prism-markup.min": [
		74060,
		74060
	],
	"./prism-markup.min.js": [
		74060,
		74060
	],
	"./prism-mata": [
		86268,
		86268
	],
	"./prism-mata.js": [
		86268,
		86268
	],
	"./prism-mata.min": [
		50965,
		50965
	],
	"./prism-mata.min.js": [
		50965,
		50965
	],
	"./prism-matlab": [
		61169,
		61169
	],
	"./prism-matlab.js": [
		61169,
		61169
	],
	"./prism-matlab.min": [
		55354,
		55354
	],
	"./prism-matlab.min.js": [
		55354,
		55354
	],
	"./prism-maxscript": [
		33965,
		33965
	],
	"./prism-maxscript.js": [
		33965,
		33965
	],
	"./prism-maxscript.min": [
		69507,
		69507
	],
	"./prism-maxscript.min.js": [
		69507,
		69507
	],
	"./prism-mel": [
		16185,
		16185
	],
	"./prism-mel.js": [
		16185,
		16185
	],
	"./prism-mel.min": [
		52357,
		52357
	],
	"./prism-mel.min.js": [
		52357,
		52357
	],
	"./prism-mermaid": [
		23099,
		23099
	],
	"./prism-mermaid.js": [
		23099,
		23099
	],
	"./prism-mermaid.min": [
		9509,
		9509
	],
	"./prism-mermaid.min.js": [
		9509,
		9509
	],
	"./prism-metafont": [
		16554,
		16554
	],
	"./prism-metafont.js": [
		16554,
		16554
	],
	"./prism-metafont.min": [
		93340,
		93340
	],
	"./prism-metafont.min.js": [
		93340,
		93340
	],
	"./prism-mizar": [
		15101,
		15101
	],
	"./prism-mizar.js": [
		15101,
		15101
	],
	"./prism-mizar.min": [
		79310,
		79310
	],
	"./prism-mizar.min.js": [
		79310,
		79310
	],
	"./prism-mongodb": [
		89134,
		89134
	],
	"./prism-mongodb.js": [
		89134,
		89134
	],
	"./prism-mongodb.min": [
		85584,
		85584
	],
	"./prism-mongodb.min.js": [
		85584,
		85584
	],
	"./prism-monkey": [
		62468,
		80676
	],
	"./prism-monkey.js": [
		62468,
		80676
	],
	"./prism-monkey.min": [
		7259,
		7259
	],
	"./prism-monkey.min.js": [
		7259,
		7259
	],
	"./prism-moonscript": [
		61899,
		61899
	],
	"./prism-moonscript.js": [
		61899,
		61899
	],
	"./prism-moonscript.min": [
		65298,
		65298
	],
	"./prism-moonscript.min.js": [
		65298,
		65298
	],
	"./prism-n1ql": [
		55949,
		55949
	],
	"./prism-n1ql.js": [
		55949,
		55949
	],
	"./prism-n1ql.min": [
		86985,
		86985
	],
	"./prism-n1ql.min.js": [
		86985,
		86985
	],
	"./prism-n4js": [
		88651,
		88651
	],
	"./prism-n4js.js": [
		88651,
		88651
	],
	"./prism-n4js.min": [
		50169,
		50169
	],
	"./prism-n4js.min.js": [
		50169,
		50169
	],
	"./prism-nand2tetris-hdl": [
		80454,
		80454
	],
	"./prism-nand2tetris-hdl.js": [
		80454,
		80454
	],
	"./prism-nand2tetris-hdl.min": [
		48974,
		48974
	],
	"./prism-nand2tetris-hdl.min.js": [
		48974,
		48974
	],
	"./prism-naniscript": [
		17898,
		17898
	],
	"./prism-naniscript.js": [
		17898,
		17898
	],
	"./prism-naniscript.min": [
		42743,
		42743
	],
	"./prism-naniscript.min.js": [
		42743,
		42743
	],
	"./prism-nasm": [
		52353,
		52353
	],
	"./prism-nasm.js": [
		52353,
		52353
	],
	"./prism-nasm.min": [
		10603,
		10603
	],
	"./prism-nasm.min.js": [
		10603,
		10603
	],
	"./prism-neon": [
		77661,
		77661
	],
	"./prism-neon.js": [
		77661,
		77661
	],
	"./prism-neon.min": [
		98832,
		98832
	],
	"./prism-neon.min.js": [
		98832,
		98832
	],
	"./prism-nevod": [
		677,
		677
	],
	"./prism-nevod.js": [
		677,
		677
	],
	"./prism-nevod.min": [
		89444,
		89444
	],
	"./prism-nevod.min.js": [
		89444,
		89444
	],
	"./prism-nginx": [
		33436,
		33436
	],
	"./prism-nginx.js": [
		33436,
		33436
	],
	"./prism-nginx.min": [
		49503,
		49503
	],
	"./prism-nginx.min.js": [
		49503,
		49503
	],
	"./prism-nim": [
		35743,
		35743
	],
	"./prism-nim.js": [
		35743,
		35743
	],
	"./prism-nim.min": [
		61663,
		61663
	],
	"./prism-nim.min.js": [
		61663,
		61663
	],
	"./prism-nix": [
		58704,
		58704
	],
	"./prism-nix.js": [
		58704,
		58704
	],
	"./prism-nix.min": [
		34232,
		34232
	],
	"./prism-nix.min.js": [
		34232,
		34232
	],
	"./prism-nsis": [
		74876,
		74876
	],
	"./prism-nsis.js": [
		74876,
		74876
	],
	"./prism-nsis.min": [
		68617,
		68617
	],
	"./prism-nsis.min.js": [
		68617,
		68617
	],
	"./prism-objectivec": [
		11426,
		11426
	],
	"./prism-objectivec.js": [
		11426,
		11426
	],
	"./prism-objectivec.min": [
		51637,
		51637
	],
	"./prism-objectivec.min.js": [
		51637,
		51637
	],
	"./prism-ocaml": [
		24371,
		24371
	],
	"./prism-ocaml.js": [
		24371,
		24371
	],
	"./prism-ocaml.min": [
		37610,
		37610
	],
	"./prism-ocaml.min.js": [
		37610,
		37610
	],
	"./prism-odin": [
		35577,
		35577
	],
	"./prism-odin.js": [
		35577,
		35577
	],
	"./prism-odin.min": [
		15415,
		15415
	],
	"./prism-odin.min.js": [
		15415,
		15415
	],
	"./prism-opencl": [
		13144,
		13144
	],
	"./prism-opencl.js": [
		13144,
		13144
	],
	"./prism-opencl.min": [
		52818,
		52818
	],
	"./prism-opencl.min.js": [
		52818,
		52818
	],
	"./prism-openqasm": [
		85513,
		85513
	],
	"./prism-openqasm.js": [
		85513,
		85513
	],
	"./prism-openqasm.min": [
		19960,
		19960
	],
	"./prism-openqasm.min.js": [
		19960,
		19960
	],
	"./prism-oz": [
		903,
		903
	],
	"./prism-oz.js": [
		903,
		903
	],
	"./prism-oz.min": [
		87553,
		87553
	],
	"./prism-oz.min.js": [
		87553,
		87553
	],
	"./prism-parigp": [
		47511,
		47511
	],
	"./prism-parigp.js": [
		47511,
		47511
	],
	"./prism-parigp.min": [
		90575,
		90575
	],
	"./prism-parigp.min.js": [
		90575,
		90575
	],
	"./prism-parser": [
		40780,
		40780
	],
	"./prism-parser.js": [
		40780,
		40780
	],
	"./prism-parser.min": [
		97410,
		97410
	],
	"./prism-parser.min.js": [
		97410,
		97410
	],
	"./prism-pascal": [
		13210,
		13210
	],
	"./prism-pascal.js": [
		13210,
		13210
	],
	"./prism-pascal.min": [
		53484,
		53484
	],
	"./prism-pascal.min.js": [
		53484,
		53484
	],
	"./prism-pascaligo": [
		54332,
		54332
	],
	"./prism-pascaligo.js": [
		54332,
		54332
	],
	"./prism-pascaligo.min": [
		68000,
		68000
	],
	"./prism-pascaligo.min.js": [
		68000,
		68000
	],
	"./prism-pcaxis": [
		52892,
		52892
	],
	"./prism-pcaxis.js": [
		52892,
		52892
	],
	"./prism-pcaxis.min": [
		55863,
		55863
	],
	"./prism-pcaxis.min.js": [
		55863,
		55863
	],
	"./prism-peoplecode": [
		74984,
		74984
	],
	"./prism-peoplecode.js": [
		74984,
		74984
	],
	"./prism-peoplecode.min": [
		11025,
		11025
	],
	"./prism-peoplecode.min.js": [
		11025,
		11025
	],
	"./prism-perl": [
		20288,
		20288
	],
	"./prism-perl.js": [
		20288,
		20288
	],
	"./prism-perl.min": [
		93972,
		93972
	],
	"./prism-perl.min.js": [
		93972,
		93972
	],
	"./prism-php": [
		99945,
		99945
	],
	"./prism-php-extras": [
		89425,
		89425
	],
	"./prism-php-extras.js": [
		89425,
		89425
	],
	"./prism-php-extras.min": [
		66200,
		66200
	],
	"./prism-php-extras.min.js": [
		66200,
		66200
	],
	"./prism-php.js": [
		99945,
		99945
	],
	"./prism-php.min": [
		37675,
		37675
	],
	"./prism-php.min.js": [
		37675,
		37675
	],
	"./prism-phpdoc": [
		26280,
		26280
	],
	"./prism-phpdoc.js": [
		26280,
		26280
	],
	"./prism-phpdoc.min": [
		49724,
		49724
	],
	"./prism-phpdoc.min.js": [
		49724,
		49724
	],
	"./prism-plant-uml": [
		79457,
		79457
	],
	"./prism-plant-uml.js": [
		79457,
		79457
	],
	"./prism-plant-uml.min": [
		68912,
		68912
	],
	"./prism-plant-uml.min.js": [
		68912,
		68912
	],
	"./prism-plsql": [
		92927,
		92927
	],
	"./prism-plsql.js": [
		92927,
		92927
	],
	"./prism-plsql.min": [
		93771,
		93771
	],
	"./prism-plsql.min.js": [
		93771,
		93771
	],
	"./prism-powerquery": [
		63887,
		63887
	],
	"./prism-powerquery.js": [
		63887,
		63887
	],
	"./prism-powerquery.min": [
		43171,
		43171
	],
	"./prism-powerquery.min.js": [
		43171,
		43171
	],
	"./prism-powershell": [
		86862,
		86862
	],
	"./prism-powershell.js": [
		86862,
		86862
	],
	"./prism-powershell.min": [
		77424,
		77424
	],
	"./prism-powershell.min.js": [
		77424,
		77424
	],
	"./prism-processing": [
		97353,
		97353
	],
	"./prism-processing.js": [
		97353,
		97353
	],
	"./prism-processing.min": [
		15759,
		15759
	],
	"./prism-processing.min.js": [
		15759,
		15759
	],
	"./prism-prolog": [
		43932,
		43932
	],
	"./prism-prolog.js": [
		43932,
		43932
	],
	"./prism-prolog.min": [
		32517,
		32517
	],
	"./prism-prolog.min.js": [
		32517,
		32517
	],
	"./prism-promql": [
		17929,
		17929
	],
	"./prism-promql.js": [
		17929,
		17929
	],
	"./prism-promql.min": [
		43355,
		43355
	],
	"./prism-promql.min.js": [
		43355,
		43355
	],
	"./prism-properties": [
		45820,
		45820
	],
	"./prism-properties.js": [
		45820,
		45820
	],
	"./prism-properties.min": [
		31623,
		31623
	],
	"./prism-properties.min.js": [
		31623,
		31623
	],
	"./prism-protobuf": [
		37345,
		37345
	],
	"./prism-protobuf.js": [
		37345,
		37345
	],
	"./prism-protobuf.min": [
		98250,
		98250
	],
	"./prism-protobuf.min.js": [
		98250,
		98250
	],
	"./prism-psl": [
		70942,
		70942
	],
	"./prism-psl.js": [
		70942,
		70942
	],
	"./prism-psl.min": [
		62546,
		62546
	],
	"./prism-psl.min.js": [
		62546,
		62546
	],
	"./prism-pug": [
		93381,
		93381
	],
	"./prism-pug.js": [
		93381,
		93381
	],
	"./prism-pug.min": [
		63138,
		63138
	],
	"./prism-pug.min.js": [
		63138,
		63138
	],
	"./prism-puppet": [
		24319,
		24319
	],
	"./prism-puppet.js": [
		24319,
		24319
	],
	"./prism-puppet.min": [
		25834,
		25834
	],
	"./prism-puppet.min.js": [
		25834,
		25834
	],
	"./prism-pure": [
		9753,
		9753
	],
	"./prism-pure.js": [
		9753,
		9753
	],
	"./prism-pure.min": [
		44697,
		44697
	],
	"./prism-pure.min.js": [
		44697,
		44697
	],
	"./prism-purebasic": [
		92168,
		92168
	],
	"./prism-purebasic.js": [
		92168,
		92168
	],
	"./prism-purebasic.min": [
		57562,
		57562
	],
	"./prism-purebasic.min.js": [
		57562,
		57562
	],
	"./prism-purescript": [
		89485,
		89485
	],
	"./prism-purescript.js": [
		89485,
		89485
	],
	"./prism-purescript.min": [
		18472,
		18472
	],
	"./prism-purescript.min.js": [
		18472,
		18472
	],
	"./prism-python": [
		80366,
		80366
	],
	"./prism-python.js": [
		80366,
		80366
	],
	"./prism-python.min": [
		29208,
		29208
	],
	"./prism-python.min.js": [
		29208,
		29208
	],
	"./prism-q": [
		82939,
		82939
	],
	"./prism-q.js": [
		82939,
		82939
	],
	"./prism-q.min": [
		32055,
		32055
	],
	"./prism-q.min.js": [
		32055,
		32055
	],
	"./prism-qml": [
		84891,
		84891
	],
	"./prism-qml.js": [
		84891,
		84891
	],
	"./prism-qml.min": [
		81124,
		81124
	],
	"./prism-qml.min.js": [
		81124,
		81124
	],
	"./prism-qore": [
		94933,
		94933
	],
	"./prism-qore.js": [
		94933,
		94933
	],
	"./prism-qore.min": [
		93661,
		93661
	],
	"./prism-qore.min.js": [
		93661,
		93661
	],
	"./prism-qsharp": [
		26896,
		26896
	],
	"./prism-qsharp.js": [
		26896,
		26896
	],
	"./prism-qsharp.min": [
		10453,
		10453
	],
	"./prism-qsharp.min.js": [
		10453,
		10453
	],
	"./prism-r": [
		54803,
		54803
	],
	"./prism-r.js": [
		54803,
		54803
	],
	"./prism-r.min": [
		41704,
		41704
	],
	"./prism-r.min.js": [
		41704,
		41704
	],
	"./prism-racket": [
		24540,
		24540
	],
	"./prism-racket.js": [
		24540,
		24540
	],
	"./prism-racket.min": [
		87382,
		87382
	],
	"./prism-racket.min.js": [
		87382,
		87382
	],
	"./prism-reason": [
		28439,
		28439
	],
	"./prism-reason.js": [
		28439,
		28439
	],
	"./prism-reason.min": [
		47788,
		47788
	],
	"./prism-reason.min.js": [
		47788,
		47788
	],
	"./prism-regex": [
		49299,
		49299
	],
	"./prism-regex.js": [
		49299,
		49299
	],
	"./prism-regex.min": [
		64297,
		64297
	],
	"./prism-regex.min.js": [
		64297,
		64297
	],
	"./prism-rego": [
		2040,
		2040
	],
	"./prism-rego.js": [
		2040,
		2040
	],
	"./prism-rego.min": [
		43149,
		43149
	],
	"./prism-rego.min.js": [
		43149,
		43149
	],
	"./prism-renpy": [
		38512,
		38512
	],
	"./prism-renpy.js": [
		38512,
		38512
	],
	"./prism-renpy.min": [
		68169,
		68169
	],
	"./prism-renpy.min.js": [
		68169,
		68169
	],
	"./prism-rescript": [
		50096,
		50096
	],
	"./prism-rescript.js": [
		50096,
		50096
	],
	"./prism-rescript.min": [
		89064,
		89064
	],
	"./prism-rescript.min.js": [
		89064,
		89064
	],
	"./prism-rest": [
		76577,
		76577
	],
	"./prism-rest.js": [
		76577,
		76577
	],
	"./prism-rest.min": [
		22369,
		22369
	],
	"./prism-rest.min.js": [
		22369,
		22369
	],
	"./prism-rip": [
		40998,
		40998
	],
	"./prism-rip.js": [
		40998,
		40998
	],
	"./prism-rip.min": [
		44538,
		44538
	],
	"./prism-rip.min.js": [
		44538,
		44538
	],
	"./prism-roboconf": [
		94840,
		94840
	],
	"./prism-roboconf.js": [
		94840,
		94840
	],
	"./prism-roboconf.min": [
		33134,
		33134
	],
	"./prism-roboconf.min.js": [
		33134,
		33134
	],
	"./prism-robotframework": [
		23449,
		23449
	],
	"./prism-robotframework.js": [
		23449,
		23449
	],
	"./prism-robotframework.min": [
		9611,
		9611
	],
	"./prism-robotframework.min.js": [
		9611,
		9611
	],
	"./prism-ruby": [
		59385,
		59385
	],
	"./prism-ruby.js": [
		59385,
		59385
	],
	"./prism-ruby.min": [
		38751,
		38751
	],
	"./prism-ruby.min.js": [
		38751,
		38751
	],
	"./prism-rust": [
		70767,
		70767
	],
	"./prism-rust.js": [
		70767,
		70767
	],
	"./prism-rust.min": [
		60983,
		60983
	],
	"./prism-rust.min.js": [
		60983,
		60983
	],
	"./prism-sas": [
		71384,
		71384
	],
	"./prism-sas.js": [
		71384,
		71384
	],
	"./prism-sas.min": [
		8920,
		8920
	],
	"./prism-sas.min.js": [
		8920,
		8920
	],
	"./prism-sass": [
		89865,
		89865
	],
	"./prism-sass.js": [
		89865,
		89865
	],
	"./prism-sass.min": [
		23683,
		23683
	],
	"./prism-sass.min.js": [
		23683,
		23683
	],
	"./prism-scala": [
		12886,
		12886
	],
	"./prism-scala.js": [
		12886,
		12886
	],
	"./prism-scala.min": [
		57239,
		57239
	],
	"./prism-scala.min.js": [
		57239,
		57239
	],
	"./prism-scheme": [
		51412,
		51412
	],
	"./prism-scheme.js": [
		51412,
		51412
	],
	"./prism-scheme.min": [
		25781,
		25781
	],
	"./prism-scheme.min.js": [
		25781,
		25781
	],
	"./prism-scss": [
		92447,
		92447
	],
	"./prism-scss.js": [
		92447,
		92447
	],
	"./prism-scss.min": [
		9578,
		9578
	],
	"./prism-scss.min.js": [
		9578,
		9578
	],
	"./prism-shell-session": [
		42963,
		42963
	],
	"./prism-shell-session.js": [
		42963,
		42963
	],
	"./prism-shell-session.min": [
		98863,
		98863
	],
	"./prism-shell-session.min.js": [
		98863,
		98863
	],
	"./prism-smali": [
		10509,
		10509
	],
	"./prism-smali.js": [
		10509,
		10509
	],
	"./prism-smali.min": [
		51406,
		51406
	],
	"./prism-smali.min.js": [
		51406,
		51406
	],
	"./prism-smalltalk": [
		22738,
		22738
	],
	"./prism-smalltalk.js": [
		22738,
		22738
	],
	"./prism-smalltalk.min": [
		1122,
		1122
	],
	"./prism-smalltalk.min.js": [
		1122,
		1122
	],
	"./prism-smarty": [
		89281,
		89281
	],
	"./prism-smarty.js": [
		89281,
		89281
	],
	"./prism-smarty.min": [
		58794,
		58794
	],
	"./prism-smarty.min.js": [
		58794,
		58794
	],
	"./prism-sml": [
		9983,
		9983
	],
	"./prism-sml.js": [
		9983,
		9983
	],
	"./prism-sml.min": [
		60332,
		60332
	],
	"./prism-sml.min.js": [
		60332,
		60332
	],
	"./prism-solidity": [
		30893,
		30893
	],
	"./prism-solidity.js": [
		30893,
		30893
	],
	"./prism-solidity.min": [
		3648,
		3648
	],
	"./prism-solidity.min.js": [
		3648,
		3648
	],
	"./prism-solution-file": [
		37485,
		37485
	],
	"./prism-solution-file.js": [
		37485,
		37485
	],
	"./prism-solution-file.min": [
		44863,
		44863
	],
	"./prism-solution-file.min.js": [
		44863,
		44863
	],
	"./prism-soy": [
		84435,
		84435
	],
	"./prism-soy.js": [
		84435,
		84435
	],
	"./prism-soy.min": [
		95210,
		95210
	],
	"./prism-soy.min.js": [
		95210,
		95210
	],
	"./prism-sparql": [
		71327,
		71327
	],
	"./prism-sparql.js": [
		71327,
		71327
	],
	"./prism-sparql.min": [
		46811,
		46811
	],
	"./prism-sparql.min.js": [
		46811,
		46811
	],
	"./prism-splunk-spl": [
		612,
		612
	],
	"./prism-splunk-spl.js": [
		612,
		612
	],
	"./prism-splunk-spl.min": [
		34810,
		34810
	],
	"./prism-splunk-spl.min.js": [
		34810,
		34810
	],
	"./prism-sqf": [
		83113,
		83113
	],
	"./prism-sqf.js": [
		83113,
		83113
	],
	"./prism-sqf.min": [
		41970,
		41970
	],
	"./prism-sqf.min.js": [
		41970,
		41970
	],
	"./prism-sql": [
		35266,
		35266
	],
	"./prism-sql.js": [
		35266,
		35266
	],
	"./prism-sql.min": [
		82720,
		82720
	],
	"./prism-sql.min.js": [
		82720,
		82720
	],
	"./prism-squirrel": [
		34229,
		34229
	],
	"./prism-squirrel.js": [
		34229,
		34229
	],
	"./prism-squirrel.min": [
		84585,
		84585
	],
	"./prism-squirrel.min.js": [
		84585,
		84585
	],
	"./prism-stan": [
		65683,
		65683
	],
	"./prism-stan.js": [
		65683,
		65683
	],
	"./prism-stan.min": [
		54178,
		54178
	],
	"./prism-stan.min.js": [
		54178,
		54178
	],
	"./prism-stata": [
		12788,
		12788
	],
	"./prism-stata.js": [
		12788,
		12788
	],
	"./prism-stata.min": [
		83784,
		83784
	],
	"./prism-stata.min.js": [
		83784,
		83784
	],
	"./prism-stylus": [
		24906,
		24906
	],
	"./prism-stylus.js": [
		24906,
		24906
	],
	"./prism-stylus.min": [
		72660,
		72660
	],
	"./prism-stylus.min.js": [
		72660,
		72660
	],
	"./prism-supercollider": [
		8571,
		8571
	],
	"./prism-supercollider.js": [
		8571,
		8571
	],
	"./prism-supercollider.min": [
		97553,
		97553
	],
	"./prism-supercollider.min.js": [
		97553,
		97553
	],
	"./prism-swift": [
		90874,
		90874
	],
	"./prism-swift.js": [
		90874,
		90874
	],
	"./prism-swift.min": [
		39361,
		39361
	],
	"./prism-swift.min.js": [
		39361,
		39361
	],
	"./prism-systemd": [
		48598,
		48598
	],
	"./prism-systemd.js": [
		48598,
		48598
	],
	"./prism-systemd.min": [
		32384,
		32384
	],
	"./prism-systemd.min.js": [
		32384,
		32384
	],
	"./prism-t4-cs": [
		20601,
		20601
	],
	"./prism-t4-cs.js": [
		20601,
		20601
	],
	"./prism-t4-cs.min": [
		73233,
		73233
	],
	"./prism-t4-cs.min.js": [
		73233,
		73233
	],
	"./prism-t4-templating": [
		89239,
		89239
	],
	"./prism-t4-templating.js": [
		89239,
		89239
	],
	"./prism-t4-templating.min": [
		94413,
		94413
	],
	"./prism-t4-templating.min.js": [
		94413,
		94413
	],
	"./prism-t4-vb": [
		16241,
		16241
	],
	"./prism-t4-vb.js": [
		16241,
		16241
	],
	"./prism-t4-vb.min": [
		78305,
		78305
	],
	"./prism-t4-vb.min.js": [
		78305,
		78305
	],
	"./prism-tap": [
		46193,
		46193
	],
	"./prism-tap.js": [
		46193,
		46193
	],
	"./prism-tap.min": [
		85599,
		85599
	],
	"./prism-tap.min.js": [
		85599,
		85599
	],
	"./prism-tcl": [
		1607,
		1607
	],
	"./prism-tcl.js": [
		1607,
		1607
	],
	"./prism-tcl.min": [
		96195,
		96195
	],
	"./prism-tcl.min.js": [
		96195,
		96195
	],
	"./prism-textile": [
		60075,
		60075
	],
	"./prism-textile.js": [
		60075,
		60075
	],
	"./prism-textile.min": [
		34966,
		34966
	],
	"./prism-textile.min.js": [
		34966,
		34966
	],
	"./prism-toml": [
		9930,
		9930
	],
	"./prism-toml.js": [
		9930,
		9930
	],
	"./prism-toml.min": [
		30485,
		30485
	],
	"./prism-toml.min.js": [
		30485,
		30485
	],
	"./prism-tremor": [
		84315,
		84315
	],
	"./prism-tremor.js": [
		84315,
		84315
	],
	"./prism-tremor.min": [
		80367,
		80367
	],
	"./prism-tremor.min.js": [
		80367,
		80367
	],
	"./prism-tsx": [
		21029,
		21029
	],
	"./prism-tsx.js": [
		21029,
		21029
	],
	"./prism-tsx.min": [
		44833,
		44833
	],
	"./prism-tsx.min.js": [
		44833,
		44833
	],
	"./prism-tt2": [
		37838,
		37838
	],
	"./prism-tt2.js": [
		37838,
		37838
	],
	"./prism-tt2.min": [
		89366,
		89366
	],
	"./prism-tt2.min.js": [
		89366,
		89366
	],
	"./prism-turtle": [
		68092,
		68092
	],
	"./prism-turtle.js": [
		68092,
		68092
	],
	"./prism-turtle.min": [
		10034,
		10034
	],
	"./prism-turtle.min.js": [
		10034,
		10034
	],
	"./prism-twig": [
		71429,
		71429
	],
	"./prism-twig.js": [
		71429,
		71429
	],
	"./prism-twig.min": [
		33161,
		33161
	],
	"./prism-twig.min.js": [
		33161,
		33161
	],
	"./prism-typescript": [
		96836,
		96836
	],
	"./prism-typescript.js": [
		96836,
		96836
	],
	"./prism-typescript.min": [
		76456,
		76456
	],
	"./prism-typescript.min.js": [
		76456,
		76456
	],
	"./prism-typoscript": [
		14032,
		14032
	],
	"./prism-typoscript.js": [
		14032,
		14032
	],
	"./prism-typoscript.min": [
		42432,
		42432
	],
	"./prism-typoscript.min.js": [
		42432,
		42432
	],
	"./prism-unrealscript": [
		10196,
		10196
	],
	"./prism-unrealscript.js": [
		10196,
		10196
	],
	"./prism-unrealscript.min": [
		79133,
		79133
	],
	"./prism-unrealscript.min.js": [
		79133,
		79133
	],
	"./prism-uorazor": [
		52467,
		52467
	],
	"./prism-uorazor.js": [
		52467,
		52467
	],
	"./prism-uorazor.min": [
		6723,
		6723
	],
	"./prism-uorazor.min.js": [
		6723,
		6723
	],
	"./prism-uri": [
		65503,
		65503
	],
	"./prism-uri.js": [
		65503,
		65503
	],
	"./prism-uri.min": [
		24526,
		24526
	],
	"./prism-uri.min.js": [
		24526,
		24526
	],
	"./prism-v": [
		14641,
		14641
	],
	"./prism-v.js": [
		14641,
		14641
	],
	"./prism-v.min": [
		13384,
		13384
	],
	"./prism-v.min.js": [
		13384,
		13384
	],
	"./prism-vala": [
		30035,
		30035
	],
	"./prism-vala.js": [
		30035,
		30035
	],
	"./prism-vala.min": [
		67524,
		67524
	],
	"./prism-vala.min.js": [
		67524,
		67524
	],
	"./prism-vbnet": [
		65398,
		65398
	],
	"./prism-vbnet.js": [
		65398,
		65398
	],
	"./prism-vbnet.min": [
		89588,
		89588
	],
	"./prism-vbnet.min.js": [
		89588,
		89588
	],
	"./prism-velocity": [
		70981,
		70981
	],
	"./prism-velocity.js": [
		70981,
		70981
	],
	"./prism-velocity.min": [
		76627,
		76627
	],
	"./prism-velocity.min.js": [
		76627,
		76627
	],
	"./prism-verilog": [
		47251,
		47251
	],
	"./prism-verilog.js": [
		47251,
		47251
	],
	"./prism-verilog.min": [
		93937,
		93937
	],
	"./prism-verilog.min.js": [
		93937,
		93937
	],
	"./prism-vhdl": [
		38564,
		38564
	],
	"./prism-vhdl.js": [
		38564,
		38564
	],
	"./prism-vhdl.min": [
		377,
		377
	],
	"./prism-vhdl.min.js": [
		377,
		377
	],
	"./prism-vim": [
		34438,
		34438
	],
	"./prism-vim.js": [
		34438,
		34438
	],
	"./prism-vim.min": [
		34836,
		34836
	],
	"./prism-vim.min.js": [
		34836,
		34836
	],
	"./prism-visual-basic": [
		83082,
		83082
	],
	"./prism-visual-basic.js": [
		83082,
		83082
	],
	"./prism-visual-basic.min": [
		67964,
		67964
	],
	"./prism-visual-basic.min.js": [
		67964,
		67964
	],
	"./prism-warpscript": [
		10008,
		10008
	],
	"./prism-warpscript.js": [
		10008,
		10008
	],
	"./prism-warpscript.min": [
		80552,
		80552
	],
	"./prism-warpscript.min.js": [
		80552,
		80552
	],
	"./prism-wasm": [
		5774,
		5774
	],
	"./prism-wasm.js": [
		5774,
		5774
	],
	"./prism-wasm.min": [
		53994,
		53994
	],
	"./prism-wasm.min.js": [
		53994,
		53994
	],
	"./prism-web-idl": [
		64040,
		64040
	],
	"./prism-web-idl.js": [
		64040,
		64040
	],
	"./prism-web-idl.min": [
		42239,
		42239
	],
	"./prism-web-idl.min.js": [
		42239,
		42239
	],
	"./prism-wgsl": [
		10230,
		10230
	],
	"./prism-wgsl.js": [
		10230,
		10230
	],
	"./prism-wgsl.min": [
		58082,
		58082
	],
	"./prism-wgsl.min.js": [
		58082,
		58082
	],
	"./prism-wiki": [
		31693,
		31693
	],
	"./prism-wiki.js": [
		31693,
		31693
	],
	"./prism-wiki.min": [
		11589,
		11589
	],
	"./prism-wiki.min.js": [
		11589,
		11589
	],
	"./prism-wolfram": [
		99729,
		99729
	],
	"./prism-wolfram.js": [
		99729,
		99729
	],
	"./prism-wolfram.min": [
		18722,
		18722
	],
	"./prism-wolfram.min.js": [
		18722,
		18722
	],
	"./prism-wren": [
		45682,
		45682
	],
	"./prism-wren.js": [
		45682,
		45682
	],
	"./prism-wren.min": [
		30877,
		30877
	],
	"./prism-wren.min.js": [
		30877,
		30877
	],
	"./prism-xeora": [
		10504,
		10504
	],
	"./prism-xeora.js": [
		10504,
		10504
	],
	"./prism-xeora.min": [
		30646,
		30646
	],
	"./prism-xeora.min.js": [
		30646,
		30646
	],
	"./prism-xml-doc": [
		62349,
		62349
	],
	"./prism-xml-doc.js": [
		62349,
		62349
	],
	"./prism-xml-doc.min": [
		19883,
		19883
	],
	"./prism-xml-doc.min.js": [
		19883,
		19883
	],
	"./prism-xojo": [
		22449,
		22449
	],
	"./prism-xojo.js": [
		22449,
		22449
	],
	"./prism-xojo.min": [
		37315,
		37315
	],
	"./prism-xojo.min.js": [
		37315,
		37315
	],
	"./prism-xquery": [
		19938,
		19938
	],
	"./prism-xquery.js": [
		19938,
		19938
	],
	"./prism-xquery.min": [
		25558,
		25558
	],
	"./prism-xquery.min.js": [
		25558,
		25558
	],
	"./prism-yaml": [
		73358,
		73358
	],
	"./prism-yaml.js": [
		73358,
		73358
	],
	"./prism-yaml.min": [
		28831,
		28831
	],
	"./prism-yaml.min.js": [
		28831,
		28831
	],
	"./prism-yang": [
		2982,
		2982
	],
	"./prism-yang.js": [
		2982,
		2982
	],
	"./prism-yang.min": [
		6959,
		6959
	],
	"./prism-yang.min.js": [
		6959,
		6959
	],
	"./prism-zig": [
		857,
		857
	],
	"./prism-zig.js": [
		857,
		857
	],
	"./prism-zig.min": [
		87975,
		87975
	],
	"./prism-zig.min.js": [
		87975,
		87975
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 96316;
module.exports = webpackAsyncContext;